import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header({ user, onLogout }) {
  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/dashboard" className="logo">
          📋 Υποχρεώσεις
        </Link>
        
        <nav className="nav-menu">
          <Link to="/dashboard">Αρχική</Link>
          <Link to="/tasks">Υποχρεώσεις</Link>
          {user.is_admin && <Link to="/admin">👥 Χρήστες</Link>}
          <Link to="/tasks/new" className="btn-new-task">+ Νέα</Link>
        </nav>

        <div className="user-menu">
          <span className="user-name">{user.full_name}</span>
          <button onClick={onLogout} className="btn-logout">
            Αποσύνδεση
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
